export const fallbackLng = 'en'
export const languages = ['en', 'fr', 'ar']
export const defaultNS = 'common'
export const cookieName = 'i18next'
export const headerName = 'x-i18next-current-language'
